import { ITranslations } from 'types/common';
import { PointsTableTransFields } from './types';
import en from 'translations/en/pointsTable.json';
import pl from 'translations/pl/pointsTable.json';
import sl from 'translations/sl/pointsTable.json';

export const pointsTableTranslations: ITranslations<PointsTableTransFields> = {
  name: 'pointsTable',
  en,
  pl,
  sl,
};
